import styled, { css } from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';
import { FULLSCREEN_MODE } from '../../../lib/constants';

export const colorBody = css`
  background-color: ${ColorSF2.white};
`;
export const colorTd = css`
  background-color: ${ColorSF2.white};
`;

export const SearchAreaWrapper = styled.div`
  padding: 5px 0px;
  position: relative;
`;
export const SearchArea = styled.table`
  width: calc(100% - 10px);
  margin: 0px 5px;
  border-collapse: collapse;
  border: none;
  ${colorBody}

  & td {
    padding: 0;

    :nth-child(2) {
      ${colorTd}
    }
    :last-child {
      border: none;
    }
  }
`;
export const SearchOptionsTable = styled.table`
  width: 100%;
  height: ${props =>
    props.fullScreenMode === FULLSCREEN_MODE.timelineTile ? 32 : 120}px;
  align-items: center;
  flex-direction: column;
  border-collapse: collapse;
  border: none;

  & th {
    width: 120px;
    background-color: ${ColorSF2.lightGray};
    font-size: 12px;
    font-weight: 100;
  }
  & td {
    padding: 5px;
    font-size: 12px;
    ${colorTd}
  }
  & tr {
    border: 1px solid ${ColorSF2.mediumGray};
  }
  & th,
  td {
    border-right: 1px solid ${ColorSF2.mediumGray};
  }
`;
export const DateTimeTd = styled.td`
  ${props =>
    props.fullScreenMode === FULLSCREEN_MODE.timelineTile && 'width: 30%'};
`;
export const InputDatetimeWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
`;
export const InputTitle = styled.div`
  flex: 0 0 auto;
`;
export const InputText = styled.input`
  width: 200px;
  @media (max-width: 830px), (max-height: 530px) {
    width: 160px;
    font-size: 12px;
  }
`;
export const Greater = styled.div`
  padding: 0px 8px 0px 8px;
`;
export const TagSearchWrapper = styled.div`
  width: 100%;
  margin-top: 4px;
  display: flex;
`;
export const ItemTagWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 8px;
`;
export const TagSelect = styled.select`
  width: 150px;
  color: ${ColorSF2.mediumGray};
  &.selected {
    color: #414141;
  }
`;
export const CheckboxContents = styled.div`
  display: flex;
`;
export const CheckboxWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  margin-right: 10px;
`;
export const Checkbox = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
`;
export const DefaultCheckbox = styled.input`
  display: none;
`;
export const CheckboxLabel = styled.label`
  width: 20px;
  height: 20px;
  cursor: ${props => (props.disabled && 'default') || 'pointer'};
  opacity: ${props => props.disabled && 0.5};
`;
export const CheckboxTitle = styled.div`
  opacity: ${props => props.disabled && 0.5};
`;
export const ButtonWrapper = styled.div`
  border: 1px solid ${ColorSF2.mediumGray};
  border-left: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const SaveButton = styled.div`
  width: 100px;
  height: 31px;
  border-radius: 5px;
  margin: auto;
  padding: 0px 10px;
  border: 1px solid ${ColorSF2.mediumGray};
  color: ${ColorSF2.black};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  white-space: nowrap;
`;
export const RadioLabel = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
`;
export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  > input {
    cursor: pointer;
  }
  > label {
    font-size: 12px;
    padding-right: 4px;
  }
`;
